import ValidationInterface from "@/plans/common/validation-interface";
import { SDKCategories, SDKUCCategories, zrCategories } from "@/common/persist-cart/categories";

export default class extends ValidationInterface {
  async requires() {
    return [];
  }

  async conflicts() {
    return this.current(zrCategories).conflict(
      [...SDKCategories, ...SDKUCCategories]
    );
  }
}
